// a comment
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import * as Sentry from "@sentry/browser"

export default Route.reopen({
  appState: service(),
  store: service("ember-store"),

  init() {
    this._super(...arguments)

    // We keep track of transition counts so we know now to scroll on the first one like when
    // ember rehydrates the app
    this._transitionCount = 0
  },

  activate: function () {
    var cssClass = this.toCssClass()

    if (cssClass.search(/foundation/).length === 0) return true

    if (
      this._transitionCount > 0 &&
      cssClass !== "template-browser" &&
      cssClass !== "foundation-index" &&
      cssClass !== "lesson-template" &&
      window.scrollTo !== undefined
    ) {
      window.scrollTo(0, 0)
    }

    Sentry.addBreadcrumb({
      message: this.routeName,
      category: "route",
    })

    this.incrementProperty("_transitionCount", 1)
  },

  // Maybe get the route state here?
  // afterModel(object, transition){
  // this._super(...arguments)
  // debugger;
  // // these seem like the things to use
  // t.targetName
  // t.queryParams
  // t.intent.url
  // },

  toCssClass: function () {
    return this.routeName.replace(/\./g, "-").dasherize()
  },
})
